const subtractYears = (numOfYears: number, date = new Date()) => {
  const dateCopy = new Date(date);

  dateCopy.setFullYear(dateCopy.getFullYear() - numOfYears);

  dateCopy.setDate(dateCopy.getDate() + 1);

  return dateCopy;
};

export default subtractYears;
